<template>
  <div class="content">
    <div class="content_title">
      Пропуски Парсек
    </div>
    <div class="form-row-parse">
      <div class="form-input-parse" @change="changeVillage">
        <label for="name-input">Поселок</label>
        <select id="name-input" v-model="idVillage">
          <option
            v-for="(village, key) in villages"
            :value="village.ID"
            :key="key"
          >
            {{ village.NAME }}
          </option>
        </select>
      </div>
      <div class="form-input-parse">
        <label for="type-input">Тип</label>
        <select id="type-input" v-model="idType">
          <option value="0">Все</option>
          <option
            v-for="(group, key) in parsecGroups"
            :value="group.ID"
            :key="key"
          >
            ({{ group.TYPE }}) {{ group.NAME }}
          </option>
        </select>
      </div>
      <button @click="unloadPasses">Выгрузить</button>
    </div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "GetParsecPasses",
  props: {
    updateList: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      url: config.backend_url,
      detailUrl: "",
      parsecAccounts: [],
      showLink: true,
      login: "",
      password: "",
      server_ip: "",
      villages: "",
      idVillage: 0,
      comment: "",
      parsecGroups: "",
      idType: 0
    };
  },
  computed: {},
  watch: {},
  methods: {
    getVillages: function() {
      let self = this;
      let data = {
        url: self.url + "villages/get/",
        filter: {},
        method: "POST"
      };
      this.plants = [];
      this.$store
        .dispatch("query/sendRequest", data)
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.villages = data;
          }
        })
        .then(function() {});
    },
    getGroupsData: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "parsecgroups/get/",
          filter: { VILLAGE: this.idVillage },
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.parsecGroups = data;
          }
        });
    },
    changeVillage: function() {
      this.getGroupsData();
    },
    forceFileDownload(response) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.xls"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },
    unloadPasses() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "parsecpasses/get-passes-file/",
          responseType: "arraybuffer",
          method: "POST",
          data: {
            VILLAGE: self.idVillage,
            TYPE: self.idType
          }
        })
        .then(response => {
          this.forceFileDownload(response);
        })
        .catch(() => console.log("error occured"));
    }
  },
  created() {
    this.getVillages();
    this.detailUrl = this.$route.fullPath;
  }
};
</script>
